@if (leerling$ | async; as leerling) {
	<div class="dashboard-vakken">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="filters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/vakkeuze"
			[permanentFilterExpressions]="getDashboardFilters(leerling.leerling)"
			[overrideDefault]="getSchooljaarFilterOverride(leerling.schooljaarInfo)"
		></app-filter-panel>
		<section class="dashboard">
			<app-dashboard-header>
				@if (opleiding) {
					<div class="cl-header-subtitle">Opleiding(en): {{ opleiding }}</div>
				}
			</app-dashboard-header>
			<app-barchart-table
				[filters]="filterExpressions()"
				[permanentFilters]="getDashboardFilters(leerling.leerling)"
				[groups]="groups"
				[config]="this"
				[barchartWidth]="200"
			></app-barchart-table>
		</section>
	</div>
}
